import type { Tag } from '$lib/models/tag';

export enum CategoryType {
  Mood = 'mood',
  Genre = 'genre',
  EnergyLevel = 'energy-level',
  Instrument = 'instrument',
  Theme = 'theme',
  Type = 'type',
  SfxCategory = 'category',
}

/**
 * Generates a full link to a category or subcategory with the lang slug.
 * (i.e: /royalty-free-music/genre/rock, /de/sound-effects/category/human, /es/sound-effects/category/human/applause)
 *
 * @param langHref The function to generate the link with the lang slug.
 * @param category The category to link to.
 * @param type Type of the category.
 */
export function categoryLink(langHref: (path: string) => string, category: Tag, type: CategoryType): string {
  let categoryLink: string | null = null;
  if (type === CategoryType.Mood) {
    categoryLink = langHref('/royalty-free-music/mood/' + category.slug);
  } else if (type === CategoryType.Genre) {
    categoryLink = langHref('/royalty-free-music/genre/' + category.slug);
  } else if (type === CategoryType.EnergyLevel) {
    categoryLink = langHref('/royalty-free-music/?energyLevel=' + category.id);
  } else if (type === CategoryType.Instrument) {
    categoryLink = langHref('/royalty-free-music/instrument/' + category.slug);
  } else if (type === CategoryType.Theme) {
    categoryLink = langHref('/royalty-free-music/theme/' + category.slug);
  } else if (type === CategoryType.Type) {
    categoryLink = langHref('/royalty-free-music/?type=' + category.id);
  } else if (type === CategoryType.SfxCategory) {
    if (category.parentSlug) {
      categoryLink = langHref('/sound-effects/category/' + category.parentSlug + '/' + category.slug);
    } else {
      categoryLink = langHref('/sound-effects/category/' + category.slug);
    }
  }
  return categoryLink ?? '#';
}
